// @ts-nocheck
import { error, robotoRegular } from '@habitech/shared';
import styled from 'styled-components';

export const Container = styled.div`
    form {
        margin: 48px 24px;
        max-width: 450px;
        display: grid;
        gap: 24px;
    }
    .toggle {
        display: flex;
    }
    
    .error-text {
        font-size: 12px;
        line-height: 14px;
        color: ${error};
        padding: 8px 0;
        font-family: ${robotoRegular};
        margin: 0;
    }
`;

export const WrapperButton = styled.div`
    max-width: 100%;
    display: flex;
    gap: 24px;
    button {
        width: 100%;
        max-width: 200px;
        margin: auto;
    }
    &.checkboxs {
        flex-wrap: wrap;
    }
    &.leads {
        margin-bottom: 40px;
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        &.checkboxs {
            max-width: calc(100% + 350px);
            margin-right: -350px;
        }
    }
`;

export const TextModal = styled.div`
    font-size: 22px;
    text-align: center;
    margin: 32px;
`;

export const InputContainer = styled.div`
    .input-container {
        margin-bottom: 10px;
    }

    .values-container {
        display: flex;
        flex-wrap: wrap;
    }

    .value-item {
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 5px 10px;
        margin-right: 5px;
        margin-bottom: 5px;
    }

    input {
        padding: 5px;
    }
`;
